import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { Button, Typography, Box, Container } from '@mui/material';
import { Home, ArrowBack } from '@mui/icons-material';

export const NotFoundPage = () => {
	const { t } = useTranslation();
	const navigate = useNavigate();

	const handleGoHome = () => {
		navigate('/');
	};

	const handleGoBack = () => {
		navigate(-1);
	};

	return (
		<Container maxWidth="sm">
			<Box
				sx={{
					display: 'flex',
					flexDirection: 'column',
					alignItems: 'center',
					justifyContent: 'center',
					minHeight: '100vh',
					textAlign: 'center',
					gap: 3,
				}}
			>
				<Typography variant="h1" component="h1" sx={{ fontSize: '8rem', fontWeight: 'bold', color: 'primary.main' }}>
					404
				</Typography>
				
				<Typography variant="h4" component="h2" sx={{ mb: 2 }}>
					{t('notFound.title', 'Page Not Found')}
				</Typography>
				
				<Typography variant="body1" color="text.secondary" sx={{ mb: 4 }}>
					{t('notFound.description', 'The page you are looking for does not exist or has been moved.')}
				</Typography>
				
				<Box sx={{ display: 'flex', gap: 2, flexDirection: { xs: 'column', sm: 'row' } }}>
					<Button
						variant="contained"
						startIcon={<Home />}
						onClick={handleGoHome}
						size="large"
					>
						{t('notFound.goHome', 'Go to Home')}
					</Button>
					
					<Button
						variant="outlined"
						startIcon={<ArrowBack />}
						onClick={handleGoBack}
						size="large"
					>
						{t('notFound.goBack', 'Go Back')}
					</Button>
				</Box>
			</Box>
		</Container>
	);
}; 